import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Sparkle } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const EnrichmentStatus = () => {
  const [status, setStatus] = useState(null);
  const headers = { Authorization: `Bearer ${localStorage.getItem('admin_token')}` };

  const load = useCallback(() => {
    axios.get(`${API_URL}/api/admin/enrich-products/status`, { headers })
      .then(r => setStatus(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);

  const start = async () => {
    await axios.post(`${API_URL}/api/admin/enrich-products`, {}, { headers });
    toast.success('Gemini spec generation started');
    setTimeout(load, 1500);
  };

  if (!status) return null;
  const running = status.job?.running;
  const pct = status.total_parts ? Math.round((status.ready / status.total_parts) * 100) : 0;

  return (
    <div className="bg-[#11141D] border border-[#1E293B] rounded-lg p-6 mb-6" data-testid="enrichment-status">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-4">
          <Sparkle size={32} className="text-cyan-400" weight="duotone" />
          <div>
            <h3 className="text-lg font-['JetBrains_Mono'] font-bold text-[#F8FAFC]">AI Product Specs (Gemini Flash)</h3>
            <p className="text-[#94A3B8] text-sm" data-testid="enrichment-counts">
              {status.ready.toLocaleString()} / {status.total_parts.toLocaleString()} parts enriched ({pct}%)
              {status.failed > 0 && ` · ${status.failed} failed`}
              {running && ` · generating ${status.job.done + status.job.failed}/${status.job.total}…`}
            </p>
          </div>
        </div>
        <Button onClick={start} disabled={running} className="bg-[#0047AB] hover:bg-[#005DF0] font-['JetBrains_Mono']" data-testid="enrich-missing-btn">
          {running ? 'Generating…' : 'Generate Missing Specs'}
        </Button>
      </div>
      <div className="mt-4 h-1.5 bg-[#1E293B] rounded-full overflow-hidden">
        <div className="h-full bg-cyan-400 transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export default EnrichmentStatus;
